<template>
  <el-dialog
    title="查看物流信息"
    :visible.sync="dialogVisible"
    width="820px"
    class="dialog"
  >
    <el-form ref="form" label-width="120px">
      <el-form-item label="快递单号" prop="kuaidiNumber">
        <el-input
          v-model="data.nu"
          placeholder="请输入"
          clearable
          class="dialog-ipt"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="快递公司" prop="kuaidiCompanyCode">
        <el-select
          v-model="data.com"
          placeholder="请选择"
          clearable
          filterable
          class="dialog-ipt"
          disabled
        >
          <el-option
            :label="item.kuaidiCompanyName"
            :value="item.kuaidiCompanyCode"
            v-for="(item, index) in kuaidiCompanyOptions"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="快递信息" prop="userAddress">
        <div class="dialog-info">
          <div>
            <span>当前状态：</span
            ><span class="dialog-state">{{ data.state }}</span
            ><br />
            <span v-for="item in data.data" :key="item.ftime">
              <span class="dialog-ftime">{{ item.ftime }}</span
              ><span class="dialog-context">{{ item.context }}</span
              ><br />
            </span>
          </div>
          <!-- <div v-else>
            <span>{{ kuaidi.kuaidiInfo.msg }}</span>
          </div> -->
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getKuaidiList } from "@/api/userCenter";
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {},
      rules: {},

      kuaidiCompanyOptions: [],
    };
  },
  created() {
    this.getKuaidiCompanyList();
  },
  computed: {
    dialogVisible: {
      get: function () {
        return this.value;
      },
      set: function (val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    // 获取快递公司列表
    async getKuaidiCompanyList() {
      const data = await this.$axios.post(getKuaidiList, {});
      this.kuaidiCompanyOptions = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog {
  ::v-deep .el-dialog__body {
    padding: 10px 20px;
  }
  &-ipt {
    width: 280px;
  }
  &-info {
    max-height: 280px;
    border: 1px solid #999;
    border-radius: 5px;
    padding: 10px;
    overflow-y: auto;
  }
  &-state {
    color: #111;
    font-weight: bold;
  }
  &-ftime {
    width: 150px;
    display: inline-block;
    vertical-align: top;
  }
  &-context {
    display: inline-block;
    width: 640px;
  }
}
</style>
